export const inputClass =
  "w-full rounded-2xl border border-navy/20 bg-white px-4 py-3 text-navy placeholder:text-navy/40 transition-colors duration-150 focus:border-navy focus:outline-none focus:ring-2 focus:ring-sky aria-[invalid=true]:border-red";

export const isEmail = (value: string) => /^\S+@\S+\.\S+$/.test(value);
